import { render, staticRenderFns } from "./CommentsTab.vue?vue&type=template&id=65a3a5aa&scoped=true&"
import script from "./CommentsTab.vue?vue&type=script&lang=js&"
export * from "./CommentsTab.vue?vue&type=script&lang=js&"
import style0 from "./CommentsTab.vue?vue&type=style&index=0&id=65a3a5aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a3a5aa",
  null
  
)

export default component.exports